if (!customElements.get('arome-customer-reviews')) {
  customElements.define('arome-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.observer?.disconnect();
      this.querySelectorAll('.arome-reviews__dots').forEach(nav => nav.remove());

      const isProduct = this.classList.contains('arome-reviews--product');
      const tracks = Array.from(this.querySelectorAll('.arome-reviews__grid'));

      tracks.forEach(track => {
        if (this.dataset.autoOrder === 'true') {
          Array.from(track.children)
            .sort((a, b) => Number(a.dataset.reviewOrder) - Number(b.dataset.reviewOrder))
            .forEach(card => track.append(card));
        }
      });

      const button = this.querySelector('.arome-reviews__more');

      if (!isProduct) {
        const cards = tracks.flatMap(track => Array.from(track.children));
        cards.forEach((card, index) => card.classList.toggle('arome-review-card--extra', index >= 10));
        if (button) {
          const hasExtra = cards.length > 10;
          button.hidden = !hasExtra;
          if (hasExtra) {
            button.addEventListener('click', () => {
              const expanded = this.classList.toggle('arome-reviews--expanded');
              button.setAttribute('aria-expanded', String(expanded));
              button.firstElementChild.textContent = expanded ? button.dataset.less : button.dataset.more;
              if (!expanded) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }, { signal: this.controller.signal });
          }
        }
        return;
      }

      this.observer = new ResizeObserver(() => this.refreshDots());
      this.tracks = tracks.map((track, index) => {
        track.id = `${this.id}-track-${index}`;
        const nav = document.createElement('div');
        nav.className = 'arome-reviews__dots';
        nav.setAttribute('role', 'group');
        nav.setAttribute('aria-label', this.dataset.pageLabel);
        track.after(nav);
        const entry = { track, nav, positions: [] };
        nav.addEventListener('click', event => {
          const dot = event.target.closest('button');
          if (!dot) return;
          track.scrollTo({ left: entry.positions[Number(dot.dataset.page)], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.controller.signal });
        track.addEventListener('scroll', () => this.updateDot(entry), { passive: true, signal: this.controller.signal });
        this.observer.observe(track);
        return entry;
      });
      this.refreshDots();

      if (!button) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = this.classList.toggle('arome-reviews--expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.firstElementChild.textContent = expanded ? button.dataset.less : button.dataset.more;
        if (!expanded) this.scrollIntoView({ block: 'start', behavior: 'instant' });
      }, { signal: this.controller.signal });
    }

    refreshDots() {
      this.tracks?.forEach(entry => {
        const { track, nav } = entry;
        if (this.classList.contains('arome-reviews--expanded')) return;
        const cards = Array.from(track.children);
        const perPage = Math.max(1, Math.floor(track.clientWidth / (cards[0]?.getBoundingClientRect().width || 1)));
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        entry.positions = [];
        cards.forEach((card, index) => {
          if (index % perPage !== 0) return;
          const position = Math.min(max, card.offsetLeft - cards[0].offsetLeft);
          if (!entry.positions.includes(position)) entry.positions.push(position);
        });
        nav.replaceChildren();
        if (max < 2) return;
        entry.positions.forEach((position, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'arome-reviews__dot';
          dot.dataset.page = index;
          dot.setAttribute('aria-label', `${this.dataset.pageLabel} ${index + 1}`);
          dot.setAttribute('aria-controls', track.id);
          nav.append(dot);
        });
        this.updateDot(entry);
      });
    }

    updateDot({ track, nav, positions }) {
      let closest = 0;
      positions.forEach((position, index) => {
        if (Math.abs(position - track.scrollLeft) < Math.abs(positions[closest] - track.scrollLeft)) closest = index;
      });
      Array.from(nav.children).forEach((dot, index) => dot.setAttribute('aria-current', String(index === closest)));
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
